export default {
  title: 'Inicie sessão no seu próprio endereço',
  description:
    'Este endereço pertence a um parceiro do qual a sua conta não faz parte. Para manter a sua conta segura, inicie sessão onde normalmente o faz — o seu e-mail e a sua palavra-passe funcionam lá.',
  continue: 'Continuar para {{host}}',
  password_changed: 'A sua palavra-passe foi alterada.',
};
